import React from "react";
import PropTypes from "prop-types";
import SectionNavLoader from "./SectionNavLoader";
import EditorHeaderLoader from "./EditorHeaderLoader";
import BuilderLoader from "./BuilderLoader";

const EditorLoader = (props) => {
  return (
    <div className="w-100 h-100 flex flex-column overflow-y-hidden-ns overflow-x-hidden-ns ">
      <EditorHeaderLoader {...props} />
      <div className="flex flex-row h-100 w-100">
        <SectionNavLoader {...props} />
        <BuilderLoader {...props} />
      </div>
    </div>
  );
};

EditorLoader.defaultProps = { withPanel: false, withShimmer: true };

EditorLoader.propTypes = {
  withPanel: PropTypes.bool,
  withShimmer: PropTypes.bool
};

export default EditorLoader;
